/* eslint-disable prettier/prettier */
/* eslint-disable */

import { connectReducers } from '../../utils';
import genericReducers from '../genericReducer';
import { IReducers } from '../index';

import { GET_SPORT_CLUBS } from '../../actions/employees';
import { REQUEST, FAILURE, SUCCESS } from '../../actions/utils';

import { ICommonResponse, ILocation } from '../../api/types';

export type SportClubsState = ICommonResponse<ILocation>;

const initialState: SportClubsState = {
  content: [],
  loading: false,
};
const generic = genericReducers<SportClubsState>();
const sportClubs: IReducers<SportClubsState> = {
  [GET_SPORT_CLUBS[REQUEST]]: generic.get.request,
  [GET_SPORT_CLUBS[SUCCESS]]: generic.get.success,
  [GET_SPORT_CLUBS[FAILURE]]: generic.get.failure,
};

export default connectReducers(initialState, sportClubs);
